/* Wishlist Hero — inject item count + fix container height + ATC interception */
(function () {
  // Post-login refresh: if redirected back from login, reload to let WH re-render
  if (window.location.hash === '#wlh_login') {
    history.replaceState(null, '', window.location.pathname + window.location.search);
    window.location.reload();
    return;
  }

  var injected = false;
  var isSharedPage = window.location.pathname.indexOf('/shared/') !== -1;

  /* ========================================================================
   * 1. Intercept Wishlist Hero ATC button clicks to:
   *    a) Add line item properties (vendor, availability, badge, _upc, etc.)
   *    b) Trigger the theme's cart popup notification
   *
   * Strategy: Use event delegation with capture phase to intercept clicks
   * on ATC buttons before Wishlist Hero handles them. We stop propagation,
   * do our own /cart/add with properties, then trigger the popup.
   * ====================================================================== */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wishlist-hero-list-card-footer-add-to-cart');
    if (!btn) return;
    if (btn.disabled || btn.classList.contains('Mui-disabled')) return;
    var atcGaClass = isSharedPage ? 'ga-shared-wishlist-add-to-bag' : 'ga-wishlist-add-to-bag';
    if (!btn.classList.contains(atcGaClass)) btn.classList.add(atcGaClass);

    // Stop WH/React from handling the click (they listen on child elements).
    // Use stopPropagation (not stopImmediatePropagation) so GTM's
    // document-level listener still fires and sees the GA class.
    e.stopPropagation();
    e.preventDefault();

    // Find the card this button belongs to
    var card = btn.closest('.wishlist-hero-list-card') || btn.closest('.MuiCard-root');
    if (!card) return;

    // Get product handle from the card's product link
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return;
    var hrefMatch = (link.getAttribute('href') || '').match(/\/products\/([^?#/]+)/);
    if (!hrefMatch) return;
    var handle = hrefMatch[1];

    // Show loading state on button
    var originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.style.pointerEvents = 'none';
    btn.style.opacity = '0.6';

    // Fetch product JSON to get variant ID and properties
    fetch('/products/' + handle + '.json')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.product) throw new Error('Product not found');
        var product = data.product;

        // Get variant ID — Wishlist Hero typically uses the first available variant
        // Try to match from the card's data or use the first variant
        var variantId = null;

        // Check if button or card has variant info in data attributes
        var variantAttr = btn.getAttribute('data-variant-id') ||
                          card.getAttribute('data-variant-id') ||
                          btn.getAttribute('data-id');

        if (variantAttr) {
          variantId = variantAttr;
        } else {
          // Try to get variant from the product link query params
          var linkHref = link.getAttribute('href') || '';
          var variantMatch = linkHref.match(/variant=(\d+)/);
          if (variantMatch) {
            variantId = variantMatch[1];
          } else if (product.variants && product.variants.length > 0) {
            // Default to first available variant
            var availableVariant = product.variants.find(function (v) { return v.available; });
            variantId = availableVariant ? availableVariant.id : product.variants[0].id;
          }
        }

        if (!variantId) throw new Error('No variant found');

        // Build line item properties (async – returns a Promise)
        return window.buildLineItemProperties(product, variantId).then(function (props) {
          return { properties: props, variantId: variantId };
        });
      })
      .then(function (data) {
        // Add to cart via Shopify AJAX API
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: Number(data.variantId),
            quantity: 1,
            properties: data.properties
          })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (cartItem) {
        // Reset button
        btn.textContent = originalText;
        btn.style.pointerEvents = '';
        btn.style.opacity = '';

        if (cartItem && cartItem.status) {
          // Error from Shopify (e.g., sold out)
          btn.textContent = cartItem.message || 'Error';
          setTimeout(function () { btn.textContent = originalText; }, 3000);
          return;
        }

        // Success — show "Added" briefly
        btn.textContent = 'Added';
        setTimeout(function () { btn.textContent = originalText; }, 2000);

        // Trigger the theme's cart popup notification
        triggerCartPopup(cartItem);

        // Also update the cart icon count
        updateCartCount();
      })
      .catch(function (err) {
        console.warn('Wishlist ATC error:', err);
        btn.textContent = originalText;
        btn.style.pointerEvents = '';
        btn.style.opacity = '';
      });
  }, true); // <-- capture phase: fires before Wishlist Hero's handler

  /**
   * Build line item properties matching what the PDP sends
   */

  /**
   * Dispatch cart:update event to trigger the cart popup notification
   */
  function triggerCartPopup(cartItem) {
    var event = new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: {},
        sourceId: String(cartItem.id || ''),
        data: {
          source: 'product-form-component',
          itemCount: cartItem.quantity || 1,
          productId: String(cartItem.product_id || '')
        }
      }
    });
    document.dispatchEvent(event);
  }

  /**
   * Update the cart icon count after adding an item
   */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Update cart count badges in header
        var countEls = document.querySelectorAll('.cart-count-bubble span[aria-hidden]');
        countEls.forEach(function (el) { el.textContent = String(cart.item_count); });
        var srEls = document.querySelectorAll('.cart-count-bubble .visually-hidden');
        srEls.forEach(function (el) { el.textContent = cart.item_count + ' items'; });
        // Show bubble if hidden
        var bubbles = document.querySelectorAll('.cart-count-bubble');
        bubbles.forEach(function (b) { b.classList.remove('hidden'); });
      })
      .catch(function () {});
  }

  /* ========================================================================
   * 2. Original wishlist page DOM fixes
   * ====================================================================== */

  function fixContainerHeight() {
    var view = document.getElementById('wishlist-hero-shared-list-view') || document.querySelector('.wishlist-hero-shared-page');
    if (!view) return;

    var el = view;
    while (el && el !== document.documentElement) {
      el.style.setProperty('overflow', 'visible', 'important');
      el.style.setProperty('overflow-y', 'visible', 'important');
      el.style.setProperty('height', 'auto', 'important');
      el.style.setProperty('max-height', 'none', 'important');
      el.style.setProperty('min-height', '0', 'important');

      var computed = window.getComputedStyle(el);
      if (computed.position === 'fixed' || computed.position === 'absolute') {
        el.style.setProperty('position', 'relative', 'important');
        el.style.setProperty('top', 'auto', 'important');
        el.style.setProperty('left', 'auto', 'important');
        el.style.setProperty('right', 'auto', 'important');
        el.style.setProperty('bottom', 'auto', 'important');
      }

      el = el.parentElement;
    }
  }

  function hideShareIfEmpty() {
    var shareBars = document.querySelectorAll('.wishlist-hero-page-actions-bar');
    if (!shareBars.length) return;
    var cards = isSharedPage
      ? document.querySelectorAll('.wishlist-hero-shared-page .MuiGrid-container > .MuiGrid-item')
      : document.querySelectorAll('.wishlist-hero-list-card');
    shareBars.forEach(function (bar) {
      if (cards.length) {
        bar.classList.remove('wlh-hidden');
      } else {
        bar.classList.add('wlh-hidden');
      }
    });
  }

  function injectCount() {
    var header = document.querySelector('.wishlist-hero-page-header');
    var cards = isSharedPage
      ? document.querySelectorAll('.wishlist-hero-shared-page .MuiGrid-container > .MuiGrid-item')
      : document.querySelectorAll('.wishlist-hero-list-card');

    // On shared page, create header if missing or rename existing one
    if (isSharedPage) {
      if (!header) {
        var sharedContainer = document.querySelector('.wishlist-hero-shared-page');
        if (sharedContainer) {
          header = document.createElement('h1');
          header.className = 'wishlist-hero-page-header';
          header.setAttribute('data-wlh-injected', '1');
          header.textContent = 'A shared wishlist';
          sharedContainer.insertBefore(header, sharedContainer.firstChild);
        }
      } else {
        // Rename "My Wishlist" to "Shared Wishlist" on shared pages
        var headerText = header.textContent.trim().toLowerCase();
        if (headerText.indexOf('my') !== -1 && headerText.indexOf('wishlist') !== -1) {
          header.textContent = 'A shared wishlist';
        }
      }
    }
    if (!header) return;

    // Hide share button when empty
    hideShareIfEmpty();

    if (!cards.length) return;

    // Check if our count element still exists in the DOM
    var existingCount = document.querySelector('.wishlist-hero-item-count');
    if (existingCount) {
      // Just update the text
      existingCount.textContent = cards.length + (cards.length === 1 ? ' Item' : ' Items');
      if (!injected) injected = true;
      return;
    }

    injected = true;

    /* Move share bar inside header so it sits inline at right end */
    var shareBar = document.querySelector('.wishlist-hero-page-actions-bar');
    if (shareBar) {
      // Hide share/email buttons on shared wishlist pages
      if (isSharedPage) {
        shareBar.style.setProperty('display', 'none', 'important');
      } else {
        header.style.setProperty('position', 'relative');
        header.appendChild(shareBar);

        // Ensure send email button comes after share button
        var shareBtn = shareBar.querySelector('.wishlist-hero-footer-share-btn');
        var emailBtn = shareBar.querySelector('.wishlist-hero-footer-send-email-btn');
        if (shareBtn && !shareBtn.classList.contains('ga-wishlist-share')) shareBtn.classList.add('ga-wishlist-share');
        if (shareBtn && emailBtn) {
          shareBtn.after(emailBtn);
        }
      }
    }

    // Re-check header exists (shared page header might have been wiped)
    header = document.querySelector('.wishlist-hero-page-header');
    if (!header) return;

    var el = document.createElement('p');
    el.className = 'wishlist-hero-item-count';
    el.textContent = cards.length + (cards.length === 1 ? ' Item' : ' Items');
    header.insertAdjacentElement('afterend', el);

    var observer = new MutationObserver(function () {
      var c = isSharedPage
        ? document.querySelectorAll('.wishlist-hero-shared-page .MuiGrid-container > .MuiGrid-item')
        : document.querySelectorAll('.wishlist-hero-list-card');
      // If our count got removed, re-inject on next poll
      var countEl = document.querySelector('.wishlist-hero-item-count');
      if (!countEl) {
        injected = false;
        return;
      }
      countEl.textContent = c.length + (c.length === 1 ? ' Item' : ' Items');
      hideShareIfEmpty();
      stripVariantFromTitles();
    });
    var container = document.querySelector('.wishlisthero-customer-view-listing') || document.querySelector('.wishlist-hero-shared-page');
    if (container) observer.observe(container, { childList: true, subtree: true });
  }

  function fixLoginLink() {
    var loginBtn = document.querySelector('.wishlist-hero-list-header-login');
    if (!loginBtn || loginBtn.dataset.urlFixed) return;
    loginBtn.dataset.urlFixed = '1';

    var loginUrl = '/customer_authentication/login?return_to=%2Fa%2Fwishlist-hero%2Fwishlist%23wlh_login';

    // Replace the MUI button with a plain anchor tag
    var link = document.createElement('a');
    link.href = loginUrl;
    link.textContent = loginBtn.textContent;
    link.className = 'wishlist-hero-list-header-login ga-wishlist-sign-in';
    link.style.cssText = 'color: inherit; text-decoration: underline; font-size: inherit; cursor: pointer;';
    loginBtn.parentNode.replaceChild(link, loginBtn);

    // Move sign-in message right below the page header
    var signInBar = link.closest('.wishlist-hero-list-header');
    var pageHeader = document.querySelector('.wishlist-hero-page-header');
    if (signInBar && pageHeader) {
      pageHeader.after(signInBar);

      // On mobile, move share bar after sign-in so order is: Title → Sign-in → Share → Border
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      if (isMobile) {
        var shareBar = document.querySelector('.wishlist-hero-page-actions-bar');
        if (shareBar) {
          signInBar.after(shareBar);
        }
      }
    }
  }

  /* ========================================================================
   * 3. Replace PLP/collection wishlist heart SVGs with single-stroke path
   * ====================================================================== */
  function fixPlpWishlistSvgs() {
    var svgs = document.querySelectorAll('.wishlist-hero-custom-button svg:not([data-wlh-fixed])');
    svgs.forEach(function (svg) {
      svg.setAttribute('data-wlh-fixed', '1');
      svg.setAttribute('viewBox', '0 0 24 24');

      // Check if wishlisted via button aria-label
      var plpBtn = svg.closest('button');
      var plpLabel = plpBtn ? (plpBtn.getAttribute('aria-label') || '').toLowerCase() : '';
      var isWishlisted = plpLabel.indexOf('remove') !== -1;

      svg.setAttribute('fill', isWishlisted ? '#2f2f30' : 'none');
      svg.setAttribute('stroke', '#2f2f30');
      svg.setAttribute('stroke-width', '1.25');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round');
      svg.removeAttribute('data-prefix');
      svg.removeAttribute('data-icon');
      svg.removeAttribute('class');
      svg.innerHTML = '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>';

      // Strip inline styles on the button and wrapper so CSS can control sizing
      var btn = svg.closest('button');
      if (btn) {
        btn.style.cssText = 'height:32px;width:32px;padding:0;overflow:visible;background:none;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;color:inherit;opacity:1;';
      }
      var wrapper = svg.closest('.wishlist-hero-custom-button');
      if (wrapper) {
        wrapper.style.cssText = (wrapper.style.cssText || '').replace(/left\s*:[^;]+;?/, 'left:auto;');
        wrapper.style.setProperty('opacity', '1', 'important');
      }
      svg.style.cssText = 'width:24px;height:24px;display:block;';
    });
  }

  // Observe for dynamically injected PLP wishlist buttons
  var plpObserver = new MutationObserver(function () {
    fixPlpWishlistSvgs();
    // Force opacity on all already-fixed buttons (Wishlist Hero re-applies opacity after our fix)
    var fixedBtns = document.querySelectorAll('.wishlist-hero-custom-button button');
    fixedBtns.forEach(function (b) {
      if (b.style.opacity !== '1') {
        b.style.setProperty('opacity', '1', 'important');
      }
    });
  });
  plpObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });

  /* ========================================================================
   * 4. Strip variant details (size / color) from wishlist card titles
   * ====================================================================== */
  function stripVariantFromTitles() {
    var titles = document.querySelectorAll('.wishlist-hero-list-card-header-product-name:not([data-wlh-title-fixed])');
    titles.forEach(function (el) {
      el.setAttribute('data-wlh-title-fixed', '1');
      var text = el.textContent || '';
      // Strip variant suffix: only the last " - X / Y" segment (size / color)
      var lastDash = text.lastIndexOf(' - ');
      if (lastDash !== -1) {
        var suffix = text.substring(lastDash + 3);
        if (suffix.indexOf('/') !== -1) {
          var cleaned = text.substring(0, lastDash).trim();
          el.textContent = cleaned;
        }
      }
    });
  }

  function addGaTrackingClasses() {
    // Header wishlist icon — add class to <a> and ALL descendants (svg, path, button, span, etc.)
    // so GTM click trigger fires regardless of which inner element is the click target
    document.querySelectorAll('.wishlist-hero-header-icon').forEach(function (a) {
      if (!a.classList.contains('ga-wishlist-header-icon')) a.classList.add('ga-wishlist-header-icon');
      a.querySelectorAll('*').forEach(function (el) {
        try { if (!el.classList.contains('ga-wishlist-header-icon')) el.classList.add('ga-wishlist-header-icon'); } catch(e) {}
      });
    });
    // Wishlist page ATC — differentiate regular vs shared
    var atcClass = isSharedPage ? 'ga-shared-wishlist-add-to-bag' : 'ga-wishlist-add-to-bag';
    document.querySelectorAll('.wishlist-hero-list-card-footer-add-to-cart:not(.' + atcClass + ')').forEach(function (el) {
      el.classList.add(atcClass);
      el.querySelectorAll('*').forEach(function (child) {
        try { if (!child.classList.contains(atcClass)) child.classList.add(atcClass); } catch(e) {}
      });
    });
    // Wishlist page remove/X button
    document.querySelectorAll('.wishlist-hero-list-card-footer-delete:not(.ga-wishlist-remove)').forEach(function (el) {
      el.classList.add('ga-wishlist-remove');
      el.querySelectorAll('*').forEach(function (child) {
        try { if (!child.classList.contains('ga-wishlist-remove')) child.classList.add('ga-wishlist-remove'); } catch(e) {}
      });
    });
    // Share wishlist CTA
    document.querySelectorAll('.wishlist-hero-footer-share-btn:not(.ga-wishlist-share)').forEach(function (el) {
      el.classList.add('ga-wishlist-share');
      el.querySelectorAll('*').forEach(function (child) {
        try { if (!child.classList.contains('ga-wishlist-share')) child.classList.add('ga-wishlist-share'); } catch(e) {}
      });
    });
    // Nosto recommendation wishlist icon — only "Add to wishlist", not "Remove"
    document.querySelectorAll('nosto-dynamic-card .wishlist-hero-custom-button button[aria-label="Add to wishlist"]:not(.ga-recommendation-wishlist-add-to-bag)').forEach(function (btn) {
      btn.classList.add('ga-recommendation-wishlist-add-to-bag');
      btn.querySelectorAll('*').forEach(function (child) {
        try { if (!child.classList.contains('ga-recommendation-wishlist-add-to-bag')) child.classList.add('ga-recommendation-wishlist-add-to-bag'); } catch(e) {}
      });
      var wrapper = btn.closest('.wishlist-hero-custom-button');
      if (wrapper && !wrapper.classList.contains('ga-recommendation-wishlist-add-to-bag')) {
        wrapper.classList.add('ga-recommendation-wishlist-add-to-bag');
      }
    });
    // Strip add tracking class and add remove tracking class when button switches to "Remove from wishlist"
    document.querySelectorAll('nosto-dynamic-card .wishlist-hero-custom-button button[aria-label="Remove from wishlist"]').forEach(function (btn) {
      var wrapper = btn.closest('.wishlist-hero-custom-button');
      if (wrapper) {
        wrapper.classList.remove('ga-recommendation-wishlist-add-to-bag');
        if (!wrapper.classList.contains('ga-recommendation-wishlist-remove-to-bag')) wrapper.classList.add('ga-recommendation-wishlist-remove-to-bag');
      }
      btn.classList.remove('ga-recommendation-wishlist-add-to-bag');
      if (!btn.classList.contains('ga-recommendation-wishlist-remove-to-bag')) btn.classList.add('ga-recommendation-wishlist-remove-to-bag');
      btn.querySelectorAll('*').forEach(function (child) {
        try {
          child.classList.remove('ga-recommendation-wishlist-add-to-bag');
          if (!child.classList.contains('ga-recommendation-wishlist-remove-to-bag')) child.classList.add('ga-recommendation-wishlist-remove-to-bag');
        } catch(e) {}
      });
    });
    // Strip remove tracking class when button switches back to "Add to wishlist"
    document.querySelectorAll('nosto-dynamic-card .wishlist-hero-custom-button button[aria-label="Add to wishlist"].ga-recommendation-wishlist-remove-to-bag').forEach(function (btn) {
      var wrapper = btn.closest('.wishlist-hero-custom-button');
      if (wrapper) wrapper.classList.remove('ga-recommendation-wishlist-remove-to-bag');
      btn.classList.remove('ga-recommendation-wishlist-remove-to-bag');
      btn.querySelectorAll('*').forEach(function (child) {
        try { child.classList.remove('ga-recommendation-wishlist-remove-to-bag'); } catch(e) {}
      });
    });
    // Share popup: copy link button + all descendants
    document.querySelectorAll('.wishlist-hero-share-copy-link button:not(.ga-wishlist-copy-link)').forEach(function (el) {
      el.classList.add('ga-wishlist-copy-link');
      el.querySelectorAll('*').forEach(function (child) {
        try { if (!child.classList.contains('ga-wishlist-copy-link')) child.classList.add('ga-wishlist-copy-link'); } catch(e) {}
      });
      // Also add to the wrapper div
      var wrapper = el.closest('.wishlist-hero-share-copy-link');
      if (wrapper && !wrapper.classList.contains('ga-wishlist-copy-link')) {
        wrapper.classList.add('ga-wishlist-copy-link');
      }
    });
    // Share popup: social icons — per-platform class on button + ALL descendants
    document.querySelectorAll('.wishlist-hero-share-icons .SocialMediaShareButton:not([data-ga-share])').forEach(function (el) {
      var platform = (el.getAttribute('aria-label') || '').toLowerCase();
      if (platform) {
        el.setAttribute('data-ga-share', platform);
        var cls = 'ga-share-wishlist-' + platform;
        el.classList.add(cls);
        el.querySelectorAll('*').forEach(function (child) {
          try { if (!child.classList.contains(cls)) child.classList.add(cls); } catch(e) {}
        });
      }
    });
  }

  var poll = setInterval(function () {
    fixContainerHeight();
    injectCount();
    fixLoginLink();
    fixPlpWishlistSvgs();
    stripVariantFromTitles();
    addGaTrackingClasses();
    // On shared page, never stop polling — WH keeps re-rendering
    if (injected && !isSharedPage) clearInterval(poll);
  }, 500);
  setTimeout(function () {
    clearInterval(poll);
    // On shared page, keep a slower poll running forever
    if (isSharedPage) {
      setInterval(function () {
        // Re-check if our injected elements got wiped
        if (!document.querySelector('.wishlist-hero-item-count')) {
          injected = false;
        }
        fixContainerHeight();
        injectCount();
        stripVariantFromTitles();
      }, 1000);
    }
  }, 15000);

  // Watch for share popup dialog and re-rendered wishlist buttons
  // (MUI renders dialog at body level; WH re-renders cards after poll ends)
  var gaDebounce = null;
  var shareDialogObserver = new MutationObserver(function () {
    addGaTrackingClasses();
    // Debounced re-apply to catch React async re-renders
    clearTimeout(gaDebounce);
    gaDebounce = setTimeout(addGaTrackingClasses, 150);
  });
  shareDialogObserver.observe(document.body, { childList: true, subtree: true });

  // Capture-phase click handler
  document.addEventListener('click', function (e) {
    // Remove/X button on wishlist page
    var removeBtn = e.target.closest('.wishlist-hero-list-card-footer-delete');
    if (removeBtn) {
      removeBtn.classList.add('ga-wishlist-remove');
      try { e.target.classList.add('ga-wishlist-remove'); } catch(ex) {}
      return;
    }

    // Inside share dialog: strip ALL ga-wishlist-copy-link first,
    // then re-add only if the click is on the copy button.
    // This prevents GTM from seeing a stale copy-link class on social icon clicks.
    var shareDialog = e.target.closest('.MuiDialog-root');
    if (shareDialog) {
      shareDialog.querySelectorAll('.ga-wishlist-copy-link').forEach(function (el) {
        try { el.classList.remove('ga-wishlist-copy-link'); } catch(ex) {}
      });
      // Re-add only if clicking copy link
      var copyBtn = e.target.closest('.wishlist-hero-share-copy-link');
      if (copyBtn) {
        copyBtn.classList.add('ga-wishlist-copy-link');
        copyBtn.querySelectorAll('*').forEach(function (child) {
          try { child.classList.add('ga-wishlist-copy-link'); } catch(ex) {}
        });
      }
    }
  }, true);
})();

function initWishlistButtons() {
  // Target only unprocessed buttons to avoid re-initializing on pages
  // where hearts already work (like PDP)
  document.querySelectorAll('.wishlist-hero-custom-button:not(.wlh-initialized)').forEach(function(el) {
    el.classList.add('wlh-initialized');
    var ev = new CustomEvent("wishlist-hero-add-to-custom-element", { detail: el });
    document.dispatchEvent(ev);
  });
}

// Run after Nosto renders (preferred — no arbitrary timeout)
if (window.nostojs) {
  nostojs(function(api) {
    api.listen('postrender', function() {
      initWishlistButtons();
    });
  });
} else {
  // Fallback if Nosto isn't present on the page
  if (document.readyState === 'complete') {
    setTimeout(initWishlistButtons, 2000);
  } else {
    window.addEventListener('load', function() {
      setTimeout(initWishlistButtons, 2000);
    });
  }
}